export default __webpack_public_path__ + "static/child-piercing-2-8cee9e81960863154aea10e0504402d1.jpeg";